<template>
  <div class="flex justify-center">
    <el-button
      type="danger"
      @click="emit('logout')"
    >
      <LogOut
        class="mr-2"
        :size="16"
      />
      {{ $t('COMMON.LOGOUT') }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
import {
  LogOut,
} from "@lucide/vue";

const emit = defineEmits<{
  logout: [];
}>();
</script>
